import { Avatar, CButton, CSButton, CBackButton, CRouterLink, CLink, FeatherIcon } from '@ezio/ui'

import { App } from 'vue'

import Centered from '@ezio/ui/layouts/Centered.vue'
import Dashboard from '@/layouts/Dashboard.vue'

export const initComponents = async (app: App) => {
    app.component('avatar', Avatar)
    app.component('CBackButton', CBackButton)
    app.component('CRouterLink', CRouterLink)
    app.component('CLink', CLink)
    app.component('CButton', CButton)
    app.component('CSButton', CSButton)
    app.component('FeatherIcon', FeatherIcon)
}

export const initLayouts = async (app: App) => {
    app.component('Centered', Centered)
    app.component('Dashboard', Dashboard)
}
